import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatDate, toDate } from "../../../utils/toDate";

import printIcon from "../../../assets/printer_icon.png";
import editIcon from "../../../assets/edit_icon.png";
import closeIcon from "../../../assets/close_icon.png";
import CustomButton from "../../../components/CustomButton";
import Modal from "../../../components/Modal";
import InformationDiv from "../invoicesOfMulti/InformationDiv";
import SectionDivider from "../../../components/SectionDivider";
import InformationBox from "../../../components/InformationBox";
import PDFUploader from "../../../components/PDFUploader";
import CustomInput from "../../../components/CustomInput";
import classes from "../../../components/Modal.module.css";
import Dropdown from "../../../components/Dropdown";
import saveIcon from "../../../assets/save_icon.png";

export default function ContainerInformationModal({
  containerInfo: defaultContainerInfo,
  subCompanyInfo,
  handleClose,
  invoice,
  onContainerChange,
}) {
  const { t } = useTranslation("general");
  const [isEdit, setIsEdit] = useState(false);
  const printRef = useRef(null);
  const pdfUploaderRef = useRef(null);
  const handlePrint = () => window.print();
  const [containerInfo, setContainerInfo] = useState(defaultContainerInfo);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setContainerInfo((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const handleSaveContainer = () => {
    onContainerChange(containerInfo);
    handleClose();
  };

  return (
    <Modal
      title={t("containerDetails")}
      onClose={handleClose}
      footer={
        <section className="o-row o-row--horizontal-align_end o-row--gap-size_300">
          {/* {containerInfo.invoiceNumber ? null : (
            <CustomButton
              variant="blank"
              elementType={Link}
              title={t("edit")}
              to={`/editContainer/${containerInfo?.id}`}
              // onClick={handleEdit}
              state={containerInfo}
              icon={editIcon}
              iconSize={18}
            />
          )} */}

          {!isEdit && (
            <CustomButton
              title={t("print")}
              variant="gray"
              icon={printIcon}
              iconSize={18}
              onClick={handlePrint}
            />
          )}
          {isEdit ? (
            <>
              <CustomButton
                variant="blank"
                elementType={Link}
                title={t("cancel")}
                icon={closeIcon}
                iconSize={18}
                onClick={handleClose}
                type="button"
              />
              <CustomButton
                elementType={Link}
                title={t("save")}
                icon={saveIcon}
                iconSize={18}
                onClick={handleSaveContainer}
                type="button"
              />
            </>
          ) : (
            <CustomButton
              variant="blank"
              elementType={Link}
              title={t("edit")}
              icon={editIcon}
              iconSize={18}
              onClick={() => setIsEdit(true)}
            />
          )}
        </section>
      }
    >
      {!isEdit && (
        <div className="printing-area" ref={printRef}>
          <InformationDiv
            title="customerName"
            value={containerInfo?.customer?.name || containerInfo?.customerName}
          />
          <InformationDiv
            title="containerNumber"
            value={containerInfo?.containerNumber}
          />
          <InformationDiv
            title="expectedArrivalDate"
            value={toDate(containerInfo?.expectedArrivalDate)}
          />
          <InformationDiv
            title="finalDestination"
            value={containerInfo?.finalDestination}
          />
          <InformationDiv title="material" value={containerInfo?.material} />
          <div className="o-row o-row--vertical-align_center o-row--gap-size_600 u-margin--bottom_300">
            <div className="o-row o-row--vertical-align_center o-row--horizontal-align_space-between u-width_full-width u-max-width_200">
              <span className="t-bold_semi-bold t-text-medium ">
                {t("numberOfBoxes")}:
              </span>
              <span>{containerInfo?.numberOfBoxes}</span>
            </div>

            <div className="o-row o-row--vertical-align_center o-row--horizontal-align_space-between o-row--gap-size_300 u-max-width_200">
              <span className="t-bold_semi-bold t-text-medium">
                {t("measuringUnit")}:
              </span>
              <span>{containerInfo?.measuringUnit}</span>
            </div>
          </div>
          {/* <InformationDiv title="unitPrice" value={containerInfo?.unitPrice} /> */}
          <InformationDiv title="shipper" value={containerInfo?.shipper} />
          <InformationDiv
            title="shippingDate"
            value={toDate(containerInfo?.shippingDate)}
          />
          <InformationDiv title="subCompany" value={subCompanyInfo?.nameInAr} />
          <InformationDiv
            title="exitDate"
            value={toDate(containerInfo?.exitDate)}
          />
          {/* <InformationDiv
          title="abstractAmountForCustomer"
          value={containerInfo?.abstractAmountForCustomer}
        /> */}
          <InformationDiv
            title="finalAmountForCustomer"
            value={containerInfo?.finalAmountForCustomer}
          />
          <InformationDiv
            title="dateOfEntry"
            value={toDate(containerInfo?.dateOfEntry)}
          />
          <InformationDiv
            title="howWasPapersReceived"
            // Here, we have to translate the value too.
            value={t(containerInfo?.howWasPapersReceived)}
          />
          <InformationDiv
            title="permitsReceivingDate"
            value={toDate(containerInfo?.permitsReceivingDate)}
          />
          <InformationDiv title="notes" value={containerInfo?.notes} />
          <InformationDiv
            title="deliveryStatus"
            value={
              containerInfo?.delivered ? t("delivered") : t("notDelivered")
            }
          />
        </div>
      )}

      {isEdit && (
        <>
          <div className={classes.inputContainer}>
            <span>{t("containerNumber")}: </span>
            <div className={classes.invoiceNumberContainer}>
              <CustomInput
                name="containerNumber"
                value={containerInfo?.containerNumber}
                onChange={(e) => handleInputChange(e, 0)}
                flex
              />
            </div>
          </div>

          <div className={classes.inputContainer}>
            <span>{t("expectedArrivalDate")}: </span>
            <CustomInput
              name="expectedArrivalDate"
              type="date"
              value={formatDate(containerInfo?.expectedArrivalDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
              flex
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("finalDestination")}: </span>
            <CustomInput
              name="finalDestination"
              value={containerInfo?.finalDestination}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("material")}: </span>
            <CustomInput
              name="material"
              value={containerInfo?.material}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("numberOfBoxes")}: </span>
            <CustomInput
              name="numberOfBoxes"
              value={containerInfo?.numberOfBoxes}
              onChange={(e) => handleInputChange(e, 0)}
              type="moneyV2"
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("measuringUnit")}: </span>
            <CustomInput
              name="measuringUnit"
              value={containerInfo?.measuringUnit}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("shipper")}: </span>
            <CustomInput
              name="shipper"
              value={containerInfo?.shipper}
              onChange={(e) => handleInputChange(e, 0)}
              flex={true}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("dateOfEntry")}: </span>
            <CustomInput
              name="dateOfEntry"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.dateOfEntry)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("shippingDate")}: </span>
            <CustomInput
              name="shippingDate"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.shippingDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          <div className={classes.inputContainer}>
            <span>{t("exitDate")}: </span>
            <CustomInput
              name="exitDate"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.exitDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          {/* Permits Receiving Date */}
          <div className={classes.inputContainer}>
            <span>{t("permitsReceivingDate")}: </span>
            <CustomInput
              name="permitsReceivingDate"
              type="date"
              flex={true}
              value={formatDate(containerInfo?.permitsReceivingDate)}
              onChange={(e) => handleInputChange(e, 0, "date")}
            />
          </div>

          {/* Delivered or NOT delivered */}
          <div className={classes.inputContainer}>
            <span>{t("deliveryStatus")}: </span>
            <Dropdown
              options={[
                { title: "delivered", value: true },
                {
                  title: "notDelivered",
                  value: false,
                },
              ]}
              selected={
                containerInfo?.delivered
                  ? {
                      title: "delivered",
                      value: true,
                    }
                  : {
                      title: "notDelivered",
                      value: false,
                    }
              }
              setSelected={(status) => {
                handleInputChange(
                  {
                    target: {
                      name: "delivered",
                      value: status?.value,
                    },
                  },
                  0
                );
              }}
              flex
            />
          </div>

          {/* Notes */}
          <div className={classes.inputContainer}>
            <span className={classes.notesClass}>{t("notes")}: </span>
            <CustomInput
              name="notes"
              type="textarea"
              value={containerInfo?.notes || ""}
              onChange={(e) => handleInputChange()}
              flex={true}
            />
          </div>
          <div className="o-row o-row--horizontal-align_end">
            {/* <button
              onClick={() => handleAttemptDelete()}
              className="temp-delete-button"
              type="button"
            >
              ❌ {t("delete")}
            </button> */}
          </div>
        </>
      )}
      <PDFUploader
        ref={pdfUploaderRef}
        invoiceDocs={containerInfo.document}
        mode={"show"}
        documents={containerInfo.document}
        title="containerDocuments"
      />
    </Modal>
  );
}
